export default __webpack_public_path__ + "static/media/General's Belt of Heaven's Pass.329114a1.jpg";